export enum TemperatureLogEnum{
    CALSIUS= "CELSIUS",
	FAHRENHEIT= "FAHRENHEIT",
    UOM = "UOM"
}